module.exports = __webpack_public_path__ + "img/thumbnail_WildBoar_m_normal.b47cf810.png";